import axiosFinance from "./finance.interceptor";
console.log("Finance URL:::::::", process.env.REACT_APP_BASE_URL);
/**
 * Fetch all lines from the Finance Backend
 */
export const getAllLines = () => {
    console.log("Requesting: ", process.env.REACT_APP_FINANCE_BASE_URL + "/bulk-line");
    return axiosFinance.get("/bulk-line");
};

/**
 * Fetch all interest types from the Finance Backend
 */
export const getAllInterestTypes = () => {
    return axiosFinance.get("/bulk-interest-type");
};

/**
 * Save a complete entry (Point + Account + DailyCollections)
 */
export const saveBulkEntry = (data) => {
    return axiosFinance.post("/bulk-add-entry", data);
};
/**
 * Fetch all users from the Finance Backend
 */
export const getAllUsers = () => {
    return axiosFinance.get("/bulk-user");
};

/**
 * Fetch all accounts for editing
 */
export const getAllAccounts = () => {
    return axiosFinance.get("/bulk-account");
};

/**
 * Fetch collections for a specific account
 */
export const getCollectionsByAccount = (accountId) => {
    return axiosFinance.get(`/bulk-daily-collection?accountId=${accountId}`);
};

/**
 * Update a complete entry (Point + Account + DailyCollections)
 */
export const updateBulkEntry = (id, data) => {
    return axiosFinance.put(`/bulk-update-entry/${id}`, data);
};
